/** Everything the two ends must agree on. Both of them import this file. */

export const FRAME_RATE = 30;
export const MS_PER_SECOND = 1000;

export const MAP_SIZE = 2000;

export const PLAYER_SIZE = 10;
export const PLAYER_SPEED = 350; // pixels per second
export const KILL_SIZE_INCREASE = 0.4; // of the victim's size

/**
 * A shove, not a gait: it lasts a blink and then makes the player wait. The
 * two ends run the same countdown, so all three live here.
 */
export const DASH_SPEED = 3; // multiplies PLAYER_SPEED
export const DASH_DURATION = 150; // ms
export const DASH_COOLDOWN = 2000; // ms

export const CONTROL_POINT_SIZE = 50;
export const CONTROL_POINT_SPACING = 400;
export const CAPTURE_THRESHOLD = 20; // hits to flip a control point

/**
 * Bullets fly in a straight line at a constant speed, so the client can move
 * them itself; the server only corrects one every this many frames. They are
 * the bulk of the entities, so this is the whole reason the delta layer exists.
 */
export const BULLET_SYNC_FRAMES = 25;

/**
 * Drawing somebody **else**: the drawn position closes half of its gap with the
 * known one every `SMOOTHING_HALF_LIFE` ms, unless that gap is past
 * `TELEPORT_DISTANCE`, which is not a walk any more — a respawn, or a stalled
 * wire letting a dozen frames go at once. Our own player is drawn where it is:
 * its position is a replay of this end's own frames, not a guess to smooth.
 *
 * Both are measured, not guessed (`src/client/latency.test.ts`): the half life
 * buys smoothness and pays in **trail**, about 0.45 px of it per ms of half
 * life on a player at full speed, and 27 px of trail is nearly three body
 * radii of extra lead to aim. Steady latency moves neither number — only the
 * snapshot rate and the jitter do.
 */
export const SMOOTHING_HALF_LIFE = 60;
export const TELEPORT_DISTANCE = 150;

/** Team colours. The colour is the team: nothing else distinguishes them. */
export const TEAM_COLORS = [
  '#e6194b',
  '#3cb44b',
  '#4363d8',
  '#f58231',
  '#911eb4',
  '#42d4f4',
  '#f032e6',
];
